import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { ROUTES, STORAGE_KEYS } from 'src/constants'
import { useMe } from '../users'

const usePersistRoute = () => {
  const location = useLocation()
  const { data: user, isLoading } = useMe()

  useEffect(() => {
    let route = location.pathname

    if (route === '/') {
      if (user && !(user.accounts && user.accounts.length > 0)) {
        route = `/${ROUTES.USER}/${ROUTES.USER_DASHBOARD}`
      } else {
        route = `/${ROUTES.ACCOUNTS}`
      }
    }
    localStorage.setItem(STORAGE_KEYS.LAST_ROUTE, route)
  }, [location, isLoading])
}

export default usePersistRoute
